import modules from './modules';
import helpers from './helpers';
import * as store from './store';
import * as extension from './extension';

export { App } from './components/App';
export const app = { modules, helpers, store, extension };

globalThis.SHAKKER_APP = app;

// 对所有节点进行初始化
Object.keys(modules).forEach((name) => {
  const module = modules[name];
  // TODO @hehao 仅在这个文件使用, 是不是不用共享数据了
  const initedModules = store.getSharedData('initedModules') || {};

  // 简单处理防止重复注册
  if (initedModules[name]) return;

  initedModules[name] = true;
  store.setSharedData('initedModules', initedModules);

  module.setup?.({ module, app });
});
